export default () => window.Core.FontStyles;
